import FeatureCard from "./FeatureCard";

export default function FeatureSection() {
  return (
    <section className="py-20 px-6 bg-white">
      <h2 className="text-3xl font-bold text-center mb-12">
        Kenapa Pilih KursusCodingOnline?
      </h2>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <FeatureCard 
          title="Belajar Privat dari Nol"
          desc="Tidak perlu background IT! Mentor akan membimbingmu secara personal."
        />
        <FeatureCard 
          title="Jadwal Fleksibel"
          desc="Atur jadwal belajar sesuai waktu senggangmu, baik pagi, siang, atau malam."
        />
        <FeatureCard 
          title="Langsung Praktik Proyek"
          desc="Belajar dengan studi kasus nyata agar siap menghadapi dunia kerja."
        />
      </div>
    </section>
  );
}
